var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"r-table-block r-loading-block"},[_c('div',{staticClass:"r-spaceBlock r-loading"},[_c('img',{attrs:{"src":require('@/assets/spinning-circles.svg'),"alt":"loading. . "}})])])}
var staticRenderFns = []

export { render, staticRenderFns }